
import {
  mapState,
  mapMutations,
} from 'vuex'; 


export default {

  name: "barrais",
  props: { menu: Object },
  data() {
    return {

      modulos: {
        reportes: {
          estado: false,
          lista: []
        },
        billeteraQr: {
          estado: false,
          lista: []
        },
        otros_reportes: {
          estado: false,
          lista: []
        },
        config: {
          estado: false,
          lista: []
        },

        fs: {
          estado: false,
          lista: []
        },

        posintegrado: {
          estado: false,
          lista: []
        },

        estadisticas: {
          estado: false,
          lista: []
        },
        reps: {
          estado: false,
          lista: []
        },
        ecash: {
          estado: false,
          lista: []
        },
        cuotaCuota: {
          estado: false,
          lista: []
        },
        reportesb: {
          estado: false,
          lista: []
        },
        configb: {
          estado: false,
          lista: []
        },
        reportesc: {
          estado: false,
          lista: []
        },
       natura: {
          estado: false,
          lista: []
        },

      }

    }
  },
  created: function () {
 

    this.$http
      .post('/SERVER/scd/dashboard/', {
        a: 'br2'
      }, {
        withCredentials: true
      })
      .then(response => {

        if (response.data.data.modulos.reportes != undefined) {
          this.modulos.reportes = response.data.data.modulos.reportes
        }
        if (response.data.data.modulos.billeteraQr != undefined) {
          this.modulos.billeteraQr = response.data.data.modulos.billeteraQr
        }

        if (response.data.data.modulos.otros_reportes != undefined) {
          this.modulos.otros_reportes = response.data.data.modulos.otros_reportes
        }

        if (response.data.data.modulos.config != undefined) {
          this.modulos.config = response.data.data.modulos.config
        }

        if (response.data.data.modulos.fs != undefined) {
          this.modulos.fs = response.data.data.modulos.fs
        }

        if (response.data.data.modulos.estadisticas != undefined) {
          this.modulos.estadisticas = response.data.data.modulos.estadisticas
        }


        if (response.data.data.modulos.posintegrado != undefined) {
          this.modulos.posintegrado = response.data.data.modulos.posintegrado
        }

        if (response.data.data.modulos.reps != undefined) {
          this.modulos.reps = response.data.data.modulos.reps
        }

        if (response.data.data.modulos.ecash != undefined) {
          this.modulos.ecash = response.data.data.modulos.ecash
        }

        if (response.data.data.modulos.cuotaCuota != undefined) {
          this.modulos.cuotaCuota = response.data.data.modulos.cuotaCuota
        }


        if (response.data.data.modulos.reportesb != undefined) {
          this.modulos.reportesb = response.data.data.modulos.reportesb
        }

        if (response.data.data.modulos.configb != undefined) {
          this.modulos.configb = response.data.data.modulos.configb
        }

        if (response.data.data.modulos.reportesc != undefined) {
          this.modulos.reportesc = response.data.data.modulos.reportesc
        }
        
        if (response.data.data.modulos.natura != undefined) {
          this.modulos.natura = response.data.data.modulos.natura
        }

        $(document).ready(() => {
          $('[data-widget="tree"]').tree();
        });

      });
  },
  computed: {
    ...mapState(['user_data'])
  },
  methods: {
    deslog(ev) {
      this.$http
        .post(
          "SERVER/scd/sess/",
          {
            a: "lgof"
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status == 1) {
            let Cookies = document.cookie.split(';');
            for (var i = 0; i < Cookies.length; i++)
                document.cookie = Cookies[i] + "=;expires=" + new Date(0).toUTCString();
            window.location.href = "/";

            
          }
        });
    },
  },

  mounted() {
    console.log(this.$router.currentRoute.path)
  }

};



// WEBPACK FOOTER //
// ./src/components/general/barrais/barrais.js